module.exports = __webpack_public_path__ + "img/onboarding-icon-measurement.8cb27c80.svg";